<template>
	<div class="row" v-if="setting">
		<div class="col-md-6">
			<card header-classes="bg-dark">
				<template slot="header">
					<h3 class="mb-0 text-white">ตั้งค่าบัญชีธนาคาร</h3>
				</template>
				<div>
					<base-button type="primary" icon @click="addBankOpen = true">
						เพิ่มธนาคาร
					</base-button>
					<base-button type="primary" icon @click="addTruewalletOpen = true" v-if="hasFeature('truewallet')">
						เพิ่มทรูมันนี่วอลเล็ท
					</base-button>

					<base-checkbox v-model="copGuard" class="mt-3">
						ป้องกันการแสดงบัญชีเงินฝากทั้งหมด
					</base-checkbox>

					<div
						class="d-flex align-items-center p-3 rounded mt-3"
						:class="{
							'bg-dark': !acc.warning,
							'bg-warning': acc.warning,
						}"
						v-for="(acc, k) in setting.banks"
						:key="k"
					>
						<div>
							<h3 class="text-white mb-0">
								<i
									class="fas fa-circle mr-1"
									:class="{
										'text-success': acc.enable,
										'text-danger': !acc.enable,
									}"
								/>
								{{ acc.accountName }}
								<span
									class="badge badge-primary"
									v-if="copGuard && acc.accountNumber === setting.mainDeposit"
								>
									<i class="fas fa-check" />
								</span>
							</h3>
							<h6 class="text-white mb-0">
								{{ acc.accountNumber }} /
								{{ acc.bank.toUpperCase() | bankName }}
							</h6>
						</div>
						<div class="ml-auto">
							<base-button
								type="secondary"
								size="sm"
								@click="setMainDeposit(acc.accountNumber)"
								v-if="copGuard"
							>
								ตั้งบัญชีฝากหลัก
							</base-button>
							<base-button type="primary" size="sm" @click="editBankOpen = acc">
								แก้ไข
							</base-button>
							<base-button type="danger" size="sm" @click="deleteBank(acc.accountNumber)">
								ลบ
							</base-button>
						</div>
					</div>
				</div>
			</card>
		</div>
		<div class="col-md-6">
			<withdraw-account-panel
				:banks="setting.banks"
				:scbAccounts="setting.scbAccounts"
				:withdrawAccount="setting.withdrawAccount"
			/>

			<truewallet-deposit-with-qr-code-panel :scbAccounts="setting.scbAccounts" />
			<truewallet-deposit-with-voucher-panel />
		</div>

		<add-bank-modal :open="addBankOpen" @close="addBankOpen = false" @reloadSetting="reloadSetting" />
		<edit-bank-modal :open="editBankOpen" @close="editBankOpen = null" @reloadSetting="reloadSetting" />
		<add-truewallet-modal :open="addTruewalletOpen" @close="addTruewalletOpen = false" @reloadSetting="reloadSetting" />
	</div>
</template>

<script>
import AddBankModal from '../backend-components/Setting/AddBankModal.vue'
import EditBankModal from '../backend-components/Setting/EditBankModal.vue'
import AddTruewalletModal from '../backend-components/Setting/AddTruewalletModal.vue'
import WithdrawAccountPanel from '../backend-components/Setting/WithdrawAccountPanel'
import TruewalletDepositWithQRCodePanel from '../backend-components/Bank/TruewalletDepositWithQRCodePanel'
import TruewalletDepositWithVoucherPanel from '../backend-components/Bank/TruewalletDepositWithVoucherPanel'

import { mapGetters } from 'vuex'
import SettingService from '../services/setting.service'

export default {
	components: {
		AddBankModal,
		EditBankModal,
		AddTruewalletModal,
		WithdrawAccountPanel,
		'truewallet-deposit-with-qr-code-panel': TruewalletDepositWithQRCodePanel,
		'truewallet-deposit-with-voucher-panel': TruewalletDepositWithVoucherPanel,
	},
	data() {
		return {
			setting: null,
			addBankOpen: false,
			editBankOpen: null,
			addTruewalletOpen: false,
			copGuard: null,
		}
	},
	computed: {
		...mapGetters('auth', ['hasFeature']),
	},
	methods: {
		reloadSetting() {
			SettingService.fetchSetting().then((res) => {
				this.copGuard = res.setting.functions.copGuard
				this.setting = res.setting
			})
		},
		deleteBank(accountNumber) {
			SettingService.deleteBank(accountNumber)
				.then(({ message }) => {
					this.$notify({ type: 'success', message })
					this.reloadSetting()
				})
				.catch(({ message }) => {
					this.$notify({ type: 'danger', message })
				})
		},
		setMainDeposit(accountNumber) {
			SettingService.setMainDeposit(accountNumber)
				.then(({ message }) => {
					this.$notify({ type: 'success', message })
					this.reloadSetting()
				})
				.catch(({ message }) => {
					this.$notify({ type: 'danger', message })
				})
		},
	},
	created() {
		this.reloadSetting()
	},
	watch: {
		async copGuard(v, oldV) {
			if (oldV !== null && v !== oldV) {
				try {
					this.setting.functions.copGuard = v
					const { message } = await SettingService.saveSetting(this.setting)

					this.$notify({ type: 'success', message })
				} catch ({ message }) {
					this.$notify({ type: 'danger', message })
				}
			}
		},
	},
}
</script>
